import { Store } from "pullstate";
import { SyncStatusResponse } from "../components/Patients/services/getCloudSyncStatus";

export interface IStore {
  fcmToken?: string | null;
  RNfcmToken?: string;
  formDetails: Record<string, Record<string, any>>;
  reportDetails: Record<string, Record<string, any>>;
  uploadModal: {
    isOpen: boolean;
    hasCurrentPatient: boolean;
  };
  isEditPatientOpen: boolean;
  isLogoutOpen: boolean;
  sharingPatient?: number;
  isGetFullAccessOpen: boolean;
  enableViewerAPICall: boolean;
  enableSidebarAPICall: boolean;
  patient: Record<any, any>;
  patientDetail: Record<any, any>;
  isDarkMode: boolean | null;
  isStartingDownload: boolean;
  isChangeRegionModalOpen: boolean;
  isFindingsSettingsOpen: boolean;
  isAutomatedConditionOpen: boolean;
  isCreateUserGroup: boolean;
  isAutomatedFindingsOpen: boolean;
  isFormSelectorVisible: boolean;
  formName: string;
  formId: string;
  isIncomingForm: boolean;
  isMatchingPatientOpen: boolean;
  emergencyPatientId?: number | null;
  isEmergencyModalOpen: boolean;
  isConfirmationModalOpen: boolean;
  userSettings: Record<any, any>;
  appConfig: Record<any, any>;
  isRNTestBuild: boolean;
  RNSelectedEnv: string;
  isRNEnvSelectorOpen: boolean;
  downloadExport: boolean;
  isExportReady: boolean;
  downloadProgress: number;
  exportTimestamp: string;
  exportGenFailed: boolean;
  swiftModeEnabled: boolean;
  showExportUpdate: boolean;
  isRNAppStateChange: boolean;
  RNAppVersion: string;
  newPatientId?: string;
  isNotificationSubscribing: boolean;
  showMobileStudySelector: boolean;
  hasUpdatedStudy: boolean;
  showMobileReport: boolean;
  isQXRModality: boolean;
  isSettingsOpen: boolean;
  hasUnsavedSetting: boolean;
  selectedSetting: string;
  settingPageNo: number;
  settingParams: Record<any, any>;
  showUnsavedWarning: boolean;
  addPhoneModal: boolean;
  isRemoteAccessOpen: boolean;
  hasLicenseExpiredForSelectedPatient: boolean;
  isDiskSpaceWarning: boolean;
  patientsFileDeletionStatus: string;
  worklistSyncStatus: Record<any, any>;
  hasMobileSearch: boolean;
  worklistCloudSyncStatus: SyncStatusResponse;
  lastGoogleCheckStatus: 'online' | 'offline' | null;
  hasQsyncDataFromOnline: boolean;
  isqTrack: boolean;
  isAssistantOpen: boolean;
  isDraggableModalOpen: boolean;
  isDraggableModalMinimized: boolean;
  isDraggableModalMaximized: boolean;
  chatInputContent: string;
  formList: Record<any, any>;
  updatePatientTags: boolean;
  refetchCustomFields: boolean;
  workspaceAudibleNotifications: boolean;
}

export default new Store<IStore>({
  fcmToken: "",
  RNfcmToken: "",
  formDetails: {},
  reportDetails: {},
  uploadModal: {
    isOpen: false,
    hasCurrentPatient: false,
  },
  isEditPatientOpen: false,
  isLogoutOpen: false,
  sharingPatient: 0,
  isGetFullAccessOpen: true,
  enableViewerAPICall: true,
  enableSidebarAPICall: false,
  patient: {},
  patientDetail: {},
  isDarkMode: null,
  isStartingDownload: false,
  isChangeRegionModalOpen: false,
  isFindingsSettingsOpen: false,
  isAutomatedConditionOpen: false,
  isCreateUserGroup: false,
  isAutomatedFindingsOpen: false,
  isMatchingPatientOpen: false,
  isFormSelectorVisible: false,
  formName: "",
  formId: "",
  isIncomingForm: false,
  emergencyPatientId: null,
  isEmergencyModalOpen: false,
  isConfirmationModalOpen: false,
  userSettings: {},
  appConfig: {},
  downloadExport: false,
  isExportReady: false,
  downloadProgress: 0,
  exportTimestamp: "",
  exportGenFailed: false,
  swiftModeEnabled: false,
  isRNTestBuild: false,
  RNSelectedEnv: "PROD",
  isRNEnvSelectorOpen: false,
  showExportUpdate: false,
  isRNAppStateChange: false,
  RNAppVersion: "",
  newPatientId: "",
  isNotificationSubscribing: false,
  showMobileStudySelector: false,
  hasUpdatedStudy: false,
  isRemoteAccessOpen: false,
  showMobileReport: false,
  isQXRModality: false,
  addPhoneModal: false,
  hasLicenseExpiredForSelectedPatient: false,
  isSettingsOpen: false,
  hasUnsavedSetting: false,
  selectedSetting: "",
  settingPageNo: 0,
  settingParams: {},
  showUnsavedWarning: false,
  isDiskSpaceWarning: false,
  patientsFileDeletionStatus: "",
  worklistSyncStatus: {},
  lastGoogleCheckStatus: null,
  hasQsyncDataFromOnline: false,
  hasMobileSearch: false,
  worklistCloudSyncStatus: {},
  isqTrack: false,
  isAssistantOpen: false,
  isDraggableModalOpen: false,
  isDraggableModalMinimized: false,
  isDraggableModalMaximized: false,
  chatInputContent: "",
  formList: {},
  updatePatientTags: false,
  refetchCustomFields: false,
  workspaceAudibleNotifications: false,
});
